<template>
	<div id="data-list-list-view" class="vs-con-loading__container">
		<vs-table
			v-if="listStatusMobile.length > 0"
			ref="table"
			pagination
			search
			pagination
			:max-items="itemsPerPage"
			:data="listStatusMobile"
		>
			<template slot="thead">
				<vs-th v-if="validateColumn('name')" class="g-table--title" sort-key="category"
					>{{ $t("Name") }}
				</vs-th>
				<vs-th v-if="validateColumn('active_form')" class="g-table--title" sort-key="name"
					>{{ $t("StatusMobile.ListStatusMobile.ActiveForm") }}
				</vs-th>
				<vs-th sort-key="name" v-if="validateColumn('enable_status_resource')"
					>{{ $t("StatusMobile.ListStatusMobile.Status") }}
				</vs-th>
			</template>
			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td v-if="validateColumn('name')">
							<p class="g-table--description truncate">{{ tr.name }}</p>
						</vs-td>
						<vs-td v-if="validateColumn('active_form')">
							<vs-chip v-if="tr.active_form" class="g-table--description" transparent color="success"
								>{{ $t("StatusMobile.ListStatusMobile.Active") }}
							</vs-chip>
							<vs-chip v-else class="g-table--description" transparent color="danger"
								>{{ $t("StatusMobile.ListStatusMobile.Disabled") }}
							</vs-chip>
						</vs-td>
						<vs-td v-if="validateColumn('enable_status_resource')" class="g-table--description">
							<ul class="switch-container mt-1 w-full">
								<li>
									<vs-switch
										color="success"
										@input="setSelected($event, tr.id)"
										v-model="tr.checked"
									/>
								</li>
							</ul>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<vs-alert v-else active class="mb-5" color="primary">
			<span> {{ $t("StatusMobile.ListStatusMobile.ErrorStatus") }}. </span>
		</vs-alert>
	</div>
</template>

<script>
import moduleStatusMobile from "@/store/status-mobile/moduleStatusMobile.js";
import moduleStatusMobileManagement from "@/store/status-mobile-management/moduleStatusMobileManagement.js";
import Commons from "@/helpers/commons.js";

export default {
	name: "StatusMobileListView",
	props: {
		resource: {
			type: Object,
			default: null,
		},
		listConfiguration: {
			type: Object,
			default: () => {
				return {
					columns: ["name", "description", "active_form", "status_id", "action", "enable_status_resource"],
					action: true,
					multiple: false,
				};
			},
		},
	},
	data() {
		return {
			itemsPerPage: 10,
			isMounted: false,
			itemSelected: null,
			statusActive: 0,
			statusMobileList: [],
		};
	},
	computed: {
		validateColumn() {
			return function (columnName) {
				return this.listConfiguration.columns.find((column) => column === columnName);
			};
		},
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.listStatusMobile.length;
		},
		// lista de status mobile
		listStatusMobile() {
			return this.statusMobileList; //this.$store.state.moduleStatusMobile.statusMobile.map((status) =>({...status, checked : true}));
		},
		// lista de status
		listStatus() {
			return this.$store.state.moduleStatusMobile.status;
		},
		// lista de empresas
		listCompanies() {
			return this.$store.state.moduleStatusMobile.companies;
		},
		statusMobileUpdatePermission() {
			return this.$store.getters.checkPermission("STATUSMOBILE_U");
		},
		statusMobileDeletePermission() {
			return this.$store.getters.checkPermission("STATUSMOBILE_D");
		},
		status_name() {
			return function (status_id) {
				const found = this.listStatus.find((statu) => statu.id === status_id);
				if (found) {
					return found.name;
				}
				return "";
			};
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		setSelected(value, id) {
			this.statusMobileList = this.statusMobileList.map((status) => {
				if (status.id === id) return {...status, checked: value};
				else return {...status, checked: false};
			});
			if (value) {
				this.updateCurrentResourceStatusActive(id, this.resource.id);
			} else {
				this.updateCurrentResourceStatusActive(null, this.resource.id);
			}
		},
		// seleccion editar
		editData(data) {
			// Emite un evento al padre "StatusMobile.vue", enviando la información del Estado
			this.$emit("selectedStatusMobileEmit", data);
		},
		// Click en icono eliminar
		openConfirm(id) {
			this.itemSelected = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("StatusMobile.FormStatusMobile.Delete.Text"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.acceptAlert,
			});
		},
		// Se acepta la eliminación
		acceptAlert() {
			this.deleteData(this.itemSelected);
		},
		// Elimina el status mobile
		deleteData(id) {
			this.$vs.loading();
			// Llama la accion Vuex, "removeRole" y se le envia el id del rol
			this.$store
				.dispatch("moduleStatusMobile/removeStatus", id)
				.then((res) => {
					// Respuesta exitosxa
					// cierra load
					this.$vs.loading.close();
					// Muestra mensaje de respuesta exitoso
					this.$vs.notify({
						color: "success",
						title: this.$t("StatusMobile.FormStatusMobile.Delete.Success.Title"),
						text: this.$t("StatusMobile.FormStatusMobile.Delete.Success.Text"),
					});
				})
				.catch((err) => {
					// Respuesta erronea
					console.error(err);
					// Muestra mensaje de respta erroneo
					this.$vs.notify({
						color: "danger",
						title: this.$t("StatusMobile.FormStatusMobile.Delete.Error.Title"),
						text: this.$t("StatusMobile.FormStatusMobile.Delete.Error.Text"),
					});
				});
		},
		// Consultar status mobile
		consultStatusMobile() {
			// Consulta los estados para moviles
			this.$store
				.dispatch("moduleStatusMobile/getStatusMobile")
				.then((res) => {
					this.statusMobileList = res.data.map((status) => {
						if (status.id === this.statusActive) return {...status, checked: true};
						return {...status, checked: false};
					});
				})
				.catch((err) => {
					console.error(err);
				});
		},
		// consultar status from platform
		getStatus() {
			this.$store
				.dispatch("moduleStatusMobile/getStatus")
				.then((res) => {})
				.catch((err) => {
					console.error(err);
				});
		},
		// consultar status activo para el recurso en cuestion
		getCurrentResourceStatusActive() {
			Commons.openLoadingDiv.call(this, "data-list-list-view");
			this.$store
				.dispatch("moduleStatusMobileManagement/getStatusMobileManagementById", this.resource.id)
				.then((res) => {
					this.statusActive = res.data.status_mobile_id;
					// Consultar status mobibile cuando se inicia
					if (this.$store.state.moduleStatusMobile.statusMobile.length <= 0) {
						this.consultStatusMobile();
					} else {
						this.statusMobileList = this.$store.state.moduleStatusMobile.statusMobile.map((status) => {
							if (status.id === this.statusActive) return {...status, checked: true};
							return {...status, checked: false};
						});
					}
					Commons.closeLoadingDiv.call(this, "data-list-list-view");
				})
				.catch((err) => {
					Commons.closeLoadingDiv.call(this, "data-list-list-view");
					console.error(err);
				});
		},
		async updateCurrentResourceStatusActive(status_mobile_id, resource_id) {
			const payload = {status_mobile_id, resource_id};
			await this.$store
				.dispatch("moduleStatusMobileManagement/updateCurrentResourceStatusActive", payload)
				.then((res) => {
					this.statusActive = status_mobile_id;
					// Consultar status mobibile cuando se inicia
					if (this.$store.state.moduleStatusMobile.statusMobile.length <= 0) {
						this.consultStatusMobile();
					} else {
						this.statusMobileList = this.$store.state.moduleStatusMobile.statusMobile.map((status) => {
							if (status.id === this.statusActive) return {...status, checked: true};
							return {...status, checked: false};
						});
					}
				})
				.catch((err) => {
					this.consultStatusMobile();
					let errorMessage = err.data.reason;
					if (err.data.reason === "the resource was not found in realtime") {
						errorMessage = this.$t("StatusMobile.ListStatusMobile.ErrorStatus");
					}
					this.$vs.notify({
						color: "danger",
						title: this.$t("StatusMobile.ListStatusMobile.ErrorTitle"),
						text: errorMessage,
					});
					console.error(err); //1605
				});
		},
	},
	mounted() {
		this.isMounted = true;
		this.getCurrentResourceStatusActive();
	},
	created() {
		// Se registra el modulo
		if (!moduleStatusMobile.isRegistered) {
			this.$store.registerModule("moduleStatusMobile", moduleStatusMobile);
			moduleStatusMobile.isRegistered = true;
		}
		// Se registra el modulo
		if (!moduleStatusMobileManagement.isRegistered) {
			this.$store.registerModule("moduleStatusMobileManagement", moduleStatusMobileManagement);
			moduleStatusMobileManagement.isRegistered = true;
		}
	},
};
</script>

<style lang="scss" scoped>
#data-list-list-view {
	.vs-con-table {
		/*
          Below media-queries is fix for responsiveness of action buttons
          Note: If you change action buttons or layout of this page, Please remove below style
        */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

				td {
					padding: 10px;

					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}

					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}

				td.td-check {
					padding: 10px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
